import React from 'react';
import TrafficLandingTemplate, { LandingPageConfig } from './TrafficLandingTemplate';
import { Activity, BarChart3, Globe } from 'lucide-react';

const config: LandingPageConfig = {
    slug: 'ar/shira-traffic-mustahdaf',
    titleTag: 'شراء حركة مرور مستهدفة | Traffic Creator',
    metaDescription: 'شراء حركة مرور مستهدفة مع جلسات سكنية قابلة للقياس، استهداف حسب الدولة والجهاز، وضوابط تفاعل واضحة تظهر في Google Analytics 4.',
    keywords: 'شراء حركة مرور مستهدفة, Traffic Creator',
    primaryKeyword: 'شراء حركة مرور مستهدفة',
    secondaryKeyword: 'Traffic Creator',
    reviewCount: '518',
    ratingValue: '4.9',

    h1: 'شراء حركة مرور مستهدفة',
    subheadline: 'كل ما تحتاجه لقياس أداء موقعك وتحسين قرارات التسويق. جلسات سكنية من 190+ دولة تظهر في Google Analytics 4.',

    problemH2: 'شراء حركة مرور مستهدفة — شبكة IP سكنية',
    problemText: 'كل زيارة تستخدم مسار IP سكني مع إعدادات جلسة قابلة للضبط. يمكنك مراقبة مدة الجلسة والصفحات والبلدان داخل منصات التحليلات.',
    solutionPoints: [
        'عناوين IP سكنية حقيقية من 190+ دولة',
        'جلسات متصفح كاملة مع سلوك طبيعي',
        'كل جلسة مرئية في Google Analytics 4',
        'إعدادات تدريجية وشفافة للحملات'
    ],

    featuresH2: 'شراء حركة مرور مستهدفة — مُتحقق في GA4',
    features: [
        { icon: <Activity />, title: 'شبكة IP سكنية', description: 'جلسات عبر عناوين IP سكنية مع أنماط تصفح قابلة للضبط وقياس واضح في التحليلات.' },
        { icon: <BarChart3 />, title: 'زيارات مُتحققة في GA4', description: 'شاهد كل جلسة في الوقت الفعلي في لوحة Google Analytics 4 مع إحصائيات دقيقة.' },
        { icon: <Globe />, title: 'استهداف جغرافي دقيق', description: 'استهدف زواراً من دول ومناطق ومدن محددة لتحقيق أقصى فعالية.' }
    ],

    testimonialsH2: 'شراء حركة مرور مستهدفة — +300% زيارات',
    testimonials: [
        { name: 'محمد ع.', role: 'استراتيجي رقمي', result: '+300% زيارات', text: 'Traffic Creator يقدم بالضبط ما نحتاجه. الزيارات عالية الجودة وتظهر بشكل موثوق في GA4.', seed: 'arbuytarge1' },
        { name: 'ريم ك.', role: 'مديرة تسويق', result: 'معدل ارتداد أقل', text: 'بعد التحول لاحظنا فرقاً فورياً. زوار حقيقيون مع تفاعل حقيقي.', seed: 'arbuytarge2' },
        { name: 'علي ب.', role: 'رائد أعمال رقمي', result: 'رؤية أوضح', text: 'الزيارات من IP سكنية ساعدتنا على قراءة التفاعل وتحسين الصفحات بناءً على بيانات أوضح.', seed: 'arbuytarge3' }
    ],

    ctaH2: 'جرب مجاناً — شراء حركة مرور مستهدفة',

    faqs: [
        { question: 'كيف يعمل النظام؟', answer: 'نظامنا يوجه زواراً حقيقيين عبر عناوين IP سكنية من 190+ دولة مع محاكاة سلوك مستخدم طبيعي.' },
        { question: 'هل هو آمن لموقعي؟', answer: 'نوصي بإعدادات واقعية وتدريجية للحملات. تستخدم المنصة عناوين IP سكنية وأنماط تصفح قابلة للضبط بدلاً من وعود مطلقة.' },
        { question: 'هل ستظهر الزيارات في Google Analytics؟', answer: 'بالتأكيد. كل زيارة تُسجل بالكامل في GA4 مع مدة الجلسة والصفحات لكل زيارة والبيانات الجغرافية.' },
        { question: 'ما سرعة بدء التسليم؟', answer: 'خلال 5 دقائق من إعداد الحملة يبدأ الزوار الأوائل بالوصول إلى موقعك.' },
        { question: 'هل هناك تجربة مجانية؟', answer: 'نعم! سجّل وابدأ حملتك الأولى مجاناً. لا حاجة لبطاقة ائتمان.' }
    ],

    relatedLinks: [
        { label: 'شراء حركة مرور الموقع', to: '/ar/shira-traffic-mawqi' },
        { label: 'بوت حركة المرور', to: '/ar/bot-traffic' },
        { label: 'معزز حركة مرور SEO', to: '/ar/muazziz-traffic-seo' }
    ],

    productName: 'شراء حركة مرور مستهدفة',
    productDescription: 'شراء حركة مرور مستهدفة مع جلسات سكنية قابلة للقياس، استهداف حسب الدولة والجهاز، وضوابط تفاعل واضحة تظهر في Google Analytics 4.',

    translations: {
        navFeatures: 'الميزات',
        navPricing: 'الأسعار',
        navFaq: 'الأسئلة الشائعة',
        navLogin: 'تسجيل الدخول',
        heroBadge: 'حركة مرور عالية الجودة',
        heroCtaPrimary: 'جرب مجاناً',
        heroCtaSecondary: 'عرض الأسعار',
        heroTrust: 'يثق بنا أكثر من 10,000 مستخدم',
        heroMicrocopy: 'لا حاجة لبطاقة ائتمان. إعداد شفاف ومُتحقق في التحليلات.',
        heroLiveLabel: 'مباشر',
        heroTrafficIncrease: 'زيادة حركة المرور',
        heroActiveLabel: 'نشط',
        heroVisitorsServed: 'زوار تم خدمتهم',
        socialProofLabel: 'موثوق من قبل:',
        problemWithout: 'بدون',
        problemWith: 'مع',
        problemBullets: [
            'حركة المرور العضوية المنخفضة تحد من نموك',
            'نتائج البحث السيئة تضر بالتحويلات',
            'المنافسون يهيمنون على كلماتك المفتاحية',
            'معدل الارتداد المرتفع يضر بالسيو',
        ],
        statsCampaigns: 'حملات نشطة يومياً',
        statsCountries: 'دولة',
        statsUptime: 'وقت التشغيل',
        statsSupport: 'الدعم',
        featuresSubtitle: 'كل ما تحتاجه لقياس أداء موقعك وتحسين قرارات التسويق.',
        howItWorksH2: '3 خطوات بسيطة',
        howItWorksSteps: [
            { title: 'إعداد الحملة', desc: 'اختر البلد والجهاز وإعدادات السلوك في دقائق.' },
            { title: 'تشغيل الشبكة', desc: 'استرخِ بينما توجه منصتنا زواراً حقيقيين إلى رابطك.' },
            { title: 'تحليل النتائج', desc: 'راقب مقاييس التفاعل في Google Analytics 4.' },
        ],
        pricingH2: 'أسعار شفافة',
        pricingSubtitle: 'شراء لمرة واحدة. بدون اشتراكات. الأرصدة لا تنتهي صلاحيتها.',
        pricingMostPopular: 'الأكثر شعبية',
        pricingVisitors: 'زائر',
        pricingGetStarted: 'ابدأ الآن',
        pricingGuarantee: 'ضمان استرداد المال لمدة 30 يوماً',
        pricingDelivery: 'تسليم فوري (~5 دقائق)',
        pricingCountries: '190+ دولة',
        faqH2: 'الأسئلة الشائعة',
        ctaSubtitle: 'انضم إلى أكثر من 10,000 عميل وعزز حركة مرور موقعك اليوم.',
        ctaButtonPrimary: 'ابدأ مجاناً',
        ctaButtonSecondary: 'عرض الأسعار',
        ctaMicrocopy: 'لا حاجة لبطاقة ائتمان. إعداد شفاف ومُتحقق في التحليلات.',
        footerDescription: 'حلول لمحترفي السيو والوكالات الرقمية حول العالم.',
        footerRelatedServices: 'خدمات ذات صلة',
        footerCompany: 'الشركة',
        footerAbout: 'من نحن',
        footerBlog: 'المدونة',
        footerHelpCenter: 'مركز المساعدة',
        footerPrivacy: 'سياسة الخصوصية',
        footerImpressum: 'البيانات القانونية',
        footerStatus: 'جميع الأنظمة تعمل',
        footerBuyTraffic: 'شراء حركة مرور الموقع',
    }
};

const ArBuyTargetedTraffic: React.FC = () => {
    return <TrafficLandingTemplate config={config} />;
};

export default ArBuyTargetedTraffic;
